import { useMediaQuery } from "@mui/material";

import {
  HEADER_STARRED_ROW_COUNT_HIDE_BREAKPOINT_NUMBER,
  MOBILE_BREAKPOINT_NUMBER,
  NARROW_MOBILE_BREAKPOINT_NUMBER,
} from "../constants";

export const useIsMobile = () => {
  const isMobile = useMediaQuery(`(max-width:${MOBILE_BREAKPOINT_NUMBER}px)`);
  const isNarrowMobile = useMediaQuery(
    `(max-width:${NARROW_MOBILE_BREAKPOINT_NUMBER}px)`,
  );
  const isHeaderStarredRowCountHideViewport = useMediaQuery(
    `(max-width:${HEADER_STARRED_ROW_COUNT_HIDE_BREAKPOINT_NUMBER}px)`,
  );

  return { isMobile, isNarrowMobile, isHeaderStarredRowCountHideViewport };
};
